export default function dateFormat(date: number) {
    const newDate = new Date(date).toLocaleDateString('pt-BR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    })
    const newHour = ('0' + new Date(date).getHours()).substr(-2)
    const newMinutes = ('0' + new Date(date).getMinutes()).substr(-2)
    return `${newDate}  |  ${newHour}:${newMinutes}`
}